/**
 * Config Firebase (publique) injectée au build via `VITE_FIREBASE_CONFIG` — un JSON copié
 * depuis la console Firebase (Paramètres du projet → Applications Web → SDK). Ces clés sont
 * conçues pour vivre dans le client ; la sécurité repose sur les règles Firestore.
 */
export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  appId: string;
  storageBucket?: string;
  messagingSenderId?: string;
}

export function firebaseConfig(): FirebaseConfig | null {
  const raw = import.meta.env.VITE_FIREBASE_CONFIG as string | undefined;
  if (!raw) return null;
  try {
    const c = JSON.parse(raw) as Partial<FirebaseConfig>;
    if (c.apiKey && c.projectId && c.authDomain && c.appId) return c as FirebaseConfig;
  } catch {
    /* JSON invalide → cloud désactivé */
  }
  return null;
}
